'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');

/**
 * 토글 스위치 컴포넌트입니다.
 *
 * @component
 * @param {Object} props - 컴포넌트 props
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {boolean} [props.checked] - 스위치의 체크 상태
 * @param {boolean} [props.disabled] - 스위치의 비활성화 상태
 * @extends {ComponentPropsWithoutRef<'input'>} - input 요소의 기본 props를 상속받습니다
 *
 * @example
 * // 기본 사용법
 * <Switch checked={isOn} onChange={handleChange} />
 *
 * // 비활성화된 스위치
 * <Switch checked={true} disabled={true} />
 *
 * // 커스텀 클래스 적용
 * <Switch className="custom-switch" checked={isOn} />
 */ const Switch = (_a)=>{
    var { className, checked, disabled } = _a, rest = _tslib.__rest(_a, [
        "className",
        "checked",
        "disabled"
    ]);
    const SwitchClasses = {
        baseClass: 'peer relative h-4 w-8 rounded-full bg-w-gray-300 box-border',
        circleClass: "after:absolute after:start-[-4px] after:top-[-2px] after:size-5 after:rounded-full after:border after:border-gray-200 after:bg-w-white after:transition-all after:content-[''] box-border",
        checkedClass: 'bg-primary after:translate-x-full after:translate-x-full after:start-[-4px]',
        disabledClass: tailwindMerge.twMerge('cursor-not-allowed', checked ? 'bg-primary-100' : 'bg-w-gray-100')
    };
    return jsxRuntime.jsxs("label", {
        className: "inline-block cursor-pointer",
        "data-testid": "design-system-switch",
        children: [
            jsxRuntime.jsx("input", Object.assign({
                type: "checkbox",
                className: "peer sr-only",
                checked: checked,
                disabled: disabled
            }, rest)),
            jsxRuntime.jsx("div", {
                "data-testid": "design-system-switch-css-element",
                className: tailwindMerge.twMerge(SwitchClasses.baseClass, SwitchClasses.circleClass, checked && SwitchClasses.checkedClass, disabled && SwitchClasses.disabledClass, className)
            })
        ]
    });
};

module.exports = Switch;
